<template>
  <div class="contentComponent">
    <div id="toc" class="toc"></div>
    <div class="author">
      <div class="avatar">
        <img :src="userInfo.avatar" alt="" />
      </div>
      <div class="authorInfo">
        <div class="name"><span>作者</span>{{ userInfo.showName }}</div>
        <div class="reviseTime">
          <span> 最后修改：{{ articleContentCopy.date }} </span>
        </div>
        <div>
          <span class="reviseTime">
            浏览次数：{{ articleContentCopy.view }}
          </span>
        </div>
      </div>
      <div class="editInfo" v-if="editShow">
        <div class="more" @click="toEditArticle()">
          <span class="info">编辑</span>
        </div>
        <div class="delete" @click="toDeleteArticle()">
          <span class="info">删除</span>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="title" v-html="articleContentCopy.mainTitle"></div>
      <div class="tag">
        <ul>
          <li v-for="(item, index) in tags" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div
        class="markdown-content"
        id="article"
        v-html="articleContentCopy.render"
        v-highlight
      ></div>
    </div>
    <div class="error-wrapper" v-show="isLoading">
      <v-Loading v-show="isLoading"></v-Loading>
    </div>
    <v-comment class="comment"></v-comment>
    <v-Alert
      v-show="alertShow"
      :alertInfo="alertInfo"
      @confirm="confirm"
      @cancel="cancel"
    ></v-Alert>
  </div>
</template>

<script>
import { deatroyArticle } from "@/bmob";
import Alert from "@/components/common/alert/alert";
import Comment from "@/components/comment/comment";
import Loading from "@/components/common/loading/loading";

const HEADINGSELECTOR = "h1, h2, h3, h4";

export default {
  components: {
    "v-Alert": Alert,
    "v-Loading": Loading,
    "v-comment": Comment
  },
  data() {
    return {
      alertShow: false,
      editShow: false, //是否显示编辑
      alertInfo: {},
      articleContentCopy: this.articleContent
    };
  },
  props: {
    articleContent: {
      type: Object
    },
    tags: {
      type: Array
    },
    userInfo: {
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    articleContent() {
      //获取搜索关键词
      let key = this.$route.query.keyWord;
      let newArticleObj = this.articleContent;
      //如果有关键字，标记关键字高亮
      if (key) {
        //高亮处理
        newArticleObj = this.markInfo(key, this.articleContent);
      }
      //对图片添加查看器
      newArticleObj = this.addImgView(newArticleObj);
      //赋值处理过的数据
      this.articleContentCopy = newArticleObj;
      //如果图片是异步生成的，在图片数据更新后调用：
      this.$previewRefresh();
    }
  },
  mounted() {
    this.$nextTick(() => {
      tocbot.init({
        tocSelector: "#toc",
        contentSelector: "#article",
        headingSelector: HEADINGSELECTOR
      });
    });
    //判断是否是作者自己的文章，是的话可以编辑
    if (this.$route.query.userId === localStorage.getItem("userId")) {
      this.editShow = true;
    } else {
      this.editShow = false;
    }
  },
  updated() {
    let article = document.querySelector("#article");
    HEADINGSELECTOR.split(",").forEach((item, index) => {
      let elList = article.querySelectorAll(item);
      elList.forEach((item, i) => {
        item.setAttribute("id", `h_${index}_${i}`);
      });
    });
    this.$nextTick(() => {
      tocbot.refresh();
      // 阻止a标签默认事件，只能看不能点击
      let toc = document.querySelector("#toc");
      let aEle = toc.querySelectorAll("a");
      aEle.forEach(item => {
        item.addEventListener("click", function(e) {
          let event = e || window.event;
          event.stopPropagation();
          event.preventDefault();
        });
      });
    });
  },
  directives: {
    highlight(el) {
      let blocks = el.querySelectorAll("pre code");
      blocks.forEach(block => {
        hljs.highlightBlock(block);
      });
    }
  },
  methods: {
    toEditArticle() {
      //编辑
      let id = this.$route.query.articleId;
      this.$router.push({
        name: "BWriteBlog",
        params: { id: id, type: "blog" }
      });
    },
    toDeleteArticle() {
      //删除
      let id = this.$route.query.articleId;
      this.alertShow = true;
      this.alertInfo = { id };
    },
    markInfo(keyWord, articleObj) {
      //高亮着色
      let replaceReg = new RegExp(keyWord, "ig"); //(全文查找、忽略大小写)
      let replaceString = `<span style="color:red">${keyWord}</span>`;
      articleObj.mainTitle = articleObj.mainTitle.replace(
        replaceReg,
        replaceString
      ); //标题关键字高亮
      articleObj.render = articleObj.render.replace(replaceReg, replaceString); //文章内容关键字高亮
      return articleObj;
    },
    addImgView(articleObj) {
      //添加图片查看器
      //匹配图片标签
      var imgReg = new RegExp("(<img)(.*?)(/>)", "gi");
      //添加preview属性
      let replaceString = "$1 $2 preview='0' $3";
      articleObj.render = articleObj.render.replace(imgReg, replaceString);
      return articleObj;
    },
    imgShow(name) {
      let gallery = new Viewer(document.getElementById(name), {});
      gallery.show();
    },
    async confirm(info) {
      let { id } = info;
      await this.toDeleteFile(id); //删除云文件
      deatroyArticle(id)
        .then(res => {
          this.$emit("showMessage", res);
          // 跳转主页
          this.$router.push({ path: "/blog" });
          window.location.reload();
          this.alertShow = false;
        })
        .catch(err => {
          this.$emit("showMessage", res);
          this.alertShow = false;
        });
    },
    cancel() {
      this.alertShow = false;
    },
    toDeleteFile(id, type) {
      //删除该文章云文件
      return new Promise((resolve, reject) => {
        const delList = this.getBmobFileList(this.articleContentCopy.content);
        const del = Bmob.File();
        //传入要删除的文件地址
        delList.length && del.destroy(delList);
        resolve();
      });
    },
    getBmobFileList(content) {
      //获取该文章云文件地址
      const pattern = /!\[(.*?)\]\((.*?)\)/gm;
      const result = [];
      let matcher;
      while ((matcher = pattern.exec(content)) !== null) {
        result.push(matcher[2]);
      }
      return result;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../../assets/style/common.less");
@main: #26a69a;
.contentComponent {
  float: left;
  width: 100%;
  position: relative;
  .author {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
    .clearfixMixin();
    .avatar {
      width: 50px;
      height: 50px;
      background-color: #fff;
      float: left;
      margin-right: 18px;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .authorInfo {
      float: left;
      padding-top: 6px;
      width: 70%;
      .name {
        margin-bottom: 10px;
        .clearfixMixin();
        span {
          float: left;
          width: 30px;
          height: 17px;
          border: 1px solid @main;
          border-radius: 4px;
          margin-right: 10px;
          font-size: 12px;
          color: @main;
          line-height: 17px;
          text-align: center;
        }
      }
      .reviseTime {
        font-size: 12px;
        color: #969696;
      }
    }
    .editInfo {
      display: inline-flex;
      bottom: 0;
      right: 0;
      margin: 5px 10px;
      position: absolute;
      .info {
        font-family: "sourcesanspro", "Helvetica Neue", Arial, sans-serif;
        margin-top: 30px;
        font-size: 14px;
        line-height: 20px;
      }
      .more,
      .delete {
        float: right;
        border-radius: 2px;
        color: @main;
        cursor: pointer;
        margin-left: 8px;
        &:hover {
          color: #0d7b71;
        }
      }
    }
  }
  .container {
    padding-top: 35px;
    .title {
      word-break: break-all;
      color: #333;
      font-size: 24px;
      font-weight: 400;
    }
    .tag {
      margin: 15px 0 30px 0;
      .clearfixMixin();
      li {
        float: left;
        padding: 0 6px;
        height: 24px;
        background-color: rgba(1, 126, 102, 0.08);
        color: #2e9c92;
        line-height: 24px;
        font-size: 13px;
        margin-right: 5px;
      }
    }
  }
  h1::before,
  h2::before,
  h3::before,
  h4::before,
  h5::before,
  h6::before {
    display: block;
    content: " ";
    height: 60px;
    margin-top: -60px;
    visibility: hidden;
  }
}
@media (max-width: 1024px) {
  .contentComponent {
    width: 100%;
    .author {
      padding-top: 15px;
      padding-bottom: 30px;
      .editInfo {
        .more,
        .delete {
          margin-left: 15px;
        }
      }
    }
  }
  .toc {
    display: none;
  }
}
</style>

<style lang="less">
.toc {
  // width: 200px;
  width: 0px;
  position: fixed;
  top: 150px;
  left: 50%;
  transform: translate(160%);
  overflow-y: auto;
  line-height: 1.8;
  & > .toc-list {
    position: relative;
  }
  .toc-list {
    overflow: hidden;
    margin: 0;
    li {
      list-style: none;
    }
  }
  a.toc-link {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: currentColor;
    height: 100%;
    vertical-align: middle;
    &.node-name--H1 {
      padding-left: 10px;
    }
    &.node-name--H2 {
      padding-left: 20px;
    }
    &.node-name--H3 {
      padding-left: 30px;
    }
    &.node-name--H4 {
      padding-left: 40px;
    }
    &.node-name--H5 {
      padding-left: 50px;
    }
  }

  .is-collapsible {
    max-height: 1024px;
    overflow: hidden;
    transition: all 300ms ease-in-out;
  }

  .is-collapsed {
    max-height: 0;
  }

  .is-position-fixed {
    position: fixed !important;
    top: 0;
  }

  .is-active-link {
    font-weight: 700;
  }

  .toc-link::before {
    background-color: #eee;
    content: " ";
    display: inline-block;
    height: inherit;
    left: 0;
    margin-top: -1px;
    position: absolute;
    width: 2px;
  }
  .is-active-link {
    background: #f3f3f3;
  }
  .is-active-link::before {
    background-color: #26a599;
  }
}
/* 评论登录按钮偏上自己调整下 */
.gt-container {
  .gt-no-init {
    padding: 1.8rem 0 !important;
    p {
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// content.vue?4ecbab48